import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCommonService } from 'src/app-core/services/api-common.service';

@Injectable({
    providedIn: 'root',
})

export class ContactService {
    constructor(
        private apiCommonService: ApiCommonService) {
    }

    getGridRecords(event: any, searchQuery: string, statusQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Contacts', event, searchQuery, statusQuery, '');
    }

    getAddressesGridRecords(event: any, searchQuery: string, statusQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Address', event, searchQuery, statusQuery, '');
    }

    getRecord(contactId: string): Observable<any> {
        return this.apiCommonService.get(`Contacts/Details?Id=${contactId}`);
    }

    getContacts(searchQuery: string): Observable<any> {
        return this.apiCommonService.get(`Contacts/LookUp?${searchQuery}`);
    }

    createContact(data: any): Observable<any> {
        return this.apiCommonService.post('Contacts', data);
    }

    editContact(contactId: string): Observable<any> {
        return this.apiCommonService.get(`Contacts/Edit?Id=${contactId}`);
    }

    editContactBooking(contactId: string): Observable<any> {
        return this.apiCommonService.get(`Contacts/Edit?ContactId=${contactId}`);
    }

    updateContact(data: any): Observable<any> {
        return this.apiCommonService.post('Contacts/Update', data);
    }

    getAddress(addressId: string): Observable<object> {
        return this.apiCommonService.get(`Address/${addressId}`);
    }

    getAddresses(searchQuery: string): Observable<object> {
        return this.apiCommonService.get(`Address/LookUp?${searchQuery}`);
    }

    createAddress(data: any): Observable<any> {
        return this.apiCommonService.post('Address', data);
    }

    editAddress(accountId: string, addressId: string): Observable<any> {
        return this.apiCommonService.get(`Address/Edit?Id=${addressId}&AccountId=${accountId}`);
    }

    editAddressBooking(accountId: string, addressId: string): Observable<any> {
        return this.apiCommonService.get(`Address/Edit?AccountId=${accountId}&AddressId=${addressId}`);
    }

    updateAddress(data: any): Observable<any> {
        return this.apiCommonService.post('Address/Update', data);
    }

    exportContacts(event: any, searchQuery: string, queryString: any): Observable<object> {
        return this.apiCommonService.export('Contacts/export', event, searchQuery, queryString, '');
    }

    contactStatusUpdate(data: object): Observable<object> {
        return this.apiCommonService.put('Contacts/Delete', data);
    }

    addressesStatusUpdate(data: object): Observable<object> {
        return this.apiCommonService.put('Address/Delete', data);
    }

    getAddressDetailsList(data: any): Observable<any> {
        return this.apiCommonService.post(`Address/DetailedLookUp`, data);
    }

    createQuickContact(data: any): Observable<any> {
        return this.apiCommonService.post('Accounts/QuickContact', data);
    }

    editQuickContact(contactId: number): Observable<any> {
        return this.apiCommonService.get(`Contacts/QuickContact?Id=${contactId}`);
    }

    updateQuickContact(data: any): Observable<any> {
        return this.apiCommonService.post('Contacts/UpdateQuickContact', data);
    }

    getContactsFiltersCounts(queryParams: string): Observable<any> {
        return this.apiCommonService.get(`Contacts/LeftMenuWithCount?${queryParams}`);
    }

    getContactMigrateHistory(event: any, searchQuery: string, statusQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Contacts/Migration/Browse', event, searchQuery, statusQuery, '');
    }

    postContactMigration(data: any): Observable<any> {
        return this.apiCommonService.post('Contacts/Migrate', data);
    }

    getAccountDetails(searchQuery: string): Observable<any> {
        return this.apiCommonService.get(`Accounts/LookUpContactMigration?searchQuery=${searchQuery}`);
    }

}
